<template>
  <div class="hello">
     <div class="col-sm-4 container">

<div v-for="a in choices" :key=a.id>

    <button class="btn btn-block btn-secondary" @click="pickAnswer(a)" >{{a.text}}</button>
    <br/>
</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QuizChoices',
  props: {
    choices: Object,
    questid: String
  },
  data () {
      return {}
  },
  methods: {
      pickAnswer: function (a){
          const selected ={question: this.questid, answer:a}
          console.log('slees ', selected)
          this.$emit('submitted', this.questid, a)
      }
  },
  created () {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
